import './E404.scss';

const E404 = () => {
  return (
    <div>E404</div>
  )
};

export default E404;
